import classNames from "classnames";
import * as React from "react";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import { FormTextArea } from "../../../Shared/Form/TextArea/FormTextArea";
import { GetFontSize } from "./GetFontSize";
import { PrepareTextAreaForInput } from "./PrepareTextAreaForInput";
import * as styles from "./RootNodeName.css";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { TriggerQuickSaveAsync } from "./NodeDetails/QuickSave/QuickSaveIcon";
import { editNodeDetails_QuickSaveIcond_Id } from "./NodeDetails/EditNodeDetails";

export function NodeNameInput({
    state,
    loadedFormState,
    setState,
}: {
    state: IRootNodeFormState;
    loadedFormState: IRootNodeFormState;
    setState: React.Dispatch<React.SetStateAction<IRootNodeFormState>>;
}) {
    // For iOS
    React.useEffect(() => {
        PrepareTextAreaForInput("clickTarget_nodeName");

        // For Chrome
        setTimeout(() => {
            PrepareTextAreaForInput("clickTarget_nodeName");
        }, 100);
    }, []);

    WatchForQuickSaveHotkey(state);

    const fontSize = GetFontSize(state.rootNode);

    if (!state.parentNode) {
        console.log(`whoops!`, state);
    }

    const willGoToParentOnQuickSave =
        state.parentNode?.options?.goToParentOnQuickSave;

    return (
        <div style={{ display: `grid`, gridTemplateColumns: `1fr 1024px 1fr` }}>
            <div />
            <div>
                <FormTextArea
                    styles={{
                        border: `1px solid gold`,
                        background: `rgba(0,0,0, 0.2)`,
                        width: `calc(100vw - 105px)`,
                        fontSize,
                        marginBottom: `10px`,
                    }}
                    id="clickTarget_nodeName"
                    onChange={(value) => {
                        setState({ ...state, newName: value });
                    }}
                    hideEnterIcon
                    value={state.newName}
                    classes={classNames(styles.rootNodeName)}
                    maxWidth="1024px"
                />
                <div
                    className={StyleClassAuto({
                        fontSize: "9px",
                        color: "yellowgreen",
                        marginBottom: `10px`,
                        marginLeft: `9px`,
                    })}
                >
                    press Ctrl+Alt+Enter to save this node
                    {willGoToParentOnQuickSave
                        ? ` and go to the parent node`
                        : ``}
                </div>
            </div>
            <div />
        </div>
    );
}

function WatchForQuickSaveHotkey(state: IRootNodeFormState) {
    React.useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.ctrlKey && event.altKey && event.key === "Enter") {
                TriggerQuickSaveAsync(state, editNodeDetails_QuickSaveIcond_Id);
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
}
